import React from 'react'
import HeroSection from './hero-section'
import AppSection from './app-section'
import FeatureSection from './feature-section'
import CallToActionSection from '../../call-to-action-section'

export default function Home() {
  return (
    <React.Fragment>
      <HeroSection />
      <AppSection />
      <CallToActionSection />
      <FeatureSection />
    </React.Fragment>
  )
}
